import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "./style.scss";
import Checkbox from "../../../Assests/Img/check-box.webp";
import { MdArrowOutward } from "react-icons/md";
import { jobListings } from "../../Data";
const SeniorTaxAccountant = () => {
  const form = useRef();
  const [statusMessage, setStatusMessage] = useState("");
  const [isSending, setIsSending] = useState(false);

  const validateForm = () => {
    const formElements = form.current.elements;
    const firstName = formElements["first_name"].value.trim();
    const email = formElements["email_address"].value.trim();
    const phone = formElements["phone_number"].value.trim();
    const position = formElements["position_name"].value;
    const file = formElements["file_name"].files[0];

    if (!firstName) {
      setStatusMessage("Please enter your name.");
      return false;
    }

    // Simple email regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email || !emailRegex.test(email)) {
      setStatusMessage("Please enter a valid email address.");
      return false;
    }

    // Simple phone regex (10-15 digits)
    const phoneRegex = /^[0-9]{10,15}$/;
    if (!phone || !phoneRegex.test(phone)) {
      setStatusMessage("Please enter a valid phone number (10-15 digits).");
      return false;
    }

    if (!position) {
      setStatusMessage("Please select a position.");
      return false;
    }

    if (file) {
      const allowedTypes = [
        "image/png",
        "image/jpeg",
        "image/jpg",
        "application/pdf",
      ];
      if (!allowedTypes.includes(file.type)) {
        setStatusMessage("Only images or PDFs are allowed.");
        return false;
      }
      const maxSize = 5 * 1024 * 1024; // 5MB
      if (file.size > maxSize) {
        setStatusMessage("File size should not exceed 5MB.");
        return false;
      }
    }

    return true;
  };

  const sendApplyEmail = (e) => {
    e.preventDefault();

    if (!validateForm()) return; // Stop if validation fails

    setIsSending(true);
    setStatusMessage("Sending...");

    emailjs
      .sendForm(
        "service_vgyuibf",
        "template_2kyj625",
        form.current,
        "3-fe2hI7FyGmze-cd"
      )
      .then(
        (result) => {
          console.log(result.text);
          setStatusMessage("Email sent successfully!");
          form.current.reset(); // Clear form
        },
        (error) => {
          console.error(error.text);
          setStatusMessage(
            "Failed to send email. Check EmailJS credentials and file size."
          );
        }
      )
      .finally(() => {
        setIsSending(false);
      });
  };
  return (
    <>
      <div className="CareersJobPosition fraunces" id="SeniorTaxAccountant">
        {/* banner start */}
        <section id="inner-page-banner">
          <div className="container-fluid bgimg">
            <div className="row">
              <h1 className="main-head">Senior Tax accountant</h1>
            </div>
          </div>
        </section>
        {/*banner end */}
        {/* ======================== */}
        {/* job-overview start */}
        <section id="job-overview" className="mobile-spacing tablet-spacing">
          <div className="container-fluid p-xs-0 padding-md-0">
            <h2 className="main-head">Job Overview</h2>
            <p className="text-desc">
              The Senior Tax Accountant will prepare and review multiple tax
              projects in order to provide quality tax services and deliverables
              for our clients.
            </p>
          </div>
        </section>
        <div className="container-fluid">
          <div className="divider"></div>
        </div>
        {/* job-overview end */}
        {/* ======================== */}
        {/* Objective start */}
        <section id="objective" className="mobile-spacing tablet-spacing">
          <div className="container-fluid p-xs-0 padding-md-0">
            <h2 className="main-head">Objective</h2>
            <p className="text-desc">
              The Senior Tax Accountant will prepare and manage a variety of tax
              projects for clients. This position requires strong technical and
              communication skills to coordinate with staff, managers and
              clients to ensure timely, quality delivery of both simple and
              complex tax projects. The ideal candidate will have a strong tax
              background and be able to execute both simple and complex tax
              strategies. The position is in Naperville, Illinois. This is a
              great opportunity for someone looking to significantly expand
              their knowledge of tax law and its application.{" "}
            </p>
          </div>
        </section>
        {/* Objective end */}
        {/* ====================== */}
        {/* responsibilities-and-experience start */}
        <div
          id="responsibilities-and-experience"
          className="bgimg mobile-spacing tablet-spacing"
        >
          <div className="container-fluid inner">
            <div className="row">
              <div className="col-lg-6 col-md-12">
                <div className="responsibilities">
                  <h2 className="main-head">Responsibilities</h2>
                  <div className="icon-list">
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc">
                        Oversee and perform as necessary tax compliance
                        activities for individuals and businesses, including
                      </p>
                    </span>
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc">
                        Prepare and Review Federal and State income tax returns
                      </p>
                    </span>
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc">Tax planning and projections</p>
                    </span>
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc">
                        {" "}
                        Tax research, resolution and correspondence
                      </p>
                    </span>
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc">
                        Manage client information requests and deliverables
                      </p>
                    </span>
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc">
                        Ensure accurate, timely filing of federal, state, and
                        local tax returns
                      </p>
                    </span>
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc">
                        Ensure quality standards are maintained
                      </p>
                    </span>
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc">
                        Provide support on special tax projects and initiatives
                      </p>
                    </span>
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc">
                        Collaborate with staff, clients and management
                      </p>
                    </span>
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc">
                        Assist with Firm Initiatives as necessary{" "}
                      </p>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-12">
                <div className="experience">
                  <h2 className="main-head">Desired Skills and Experience</h2>
                  <div className="icon-list">
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc">
                        Bachelor’s degree in Accounting
                      </p>
                    </span>
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc">
                        5+ years of relevant work experience in public
                        accounting
                      </p>
                    </span>
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc"> Certified Public Accountant</p>
                    </span>
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc">
                        {" "}
                        Knowledge of finance, accounting, budgeting, and cost
                        control principles including Generally Accepted
                        Accounting Principles
                      </p>
                    </span>
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc">
                        {" "}
                        Knowledge of federal and state tax regulations
                      </p>
                    </span>
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc">
                        {" "}
                        Strong computer skills with knowledge and skills in a
                        wide variety of applications, Thomson Reuters software
                        experience a plus
                      </p>
                    </span>
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc">
                        {" "}
                        Good interpersonal, oral and written communication
                        skills
                      </p>
                    </span>
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc">
                        {" "}
                        Research orientated with problem-solving skills
                      </p>
                    </span>
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc">
                        {" "}
                        Superior attention to detail with strong organizational,
                        analytical and planning skills
                      </p>
                    </span>
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc">
                        {" "}
                        Positive attitude and ability to work collaboratively
                        with team in various levels
                      </p>
                    </span>
                    <span>
                      <img src={Checkbox} alt="Checkbox" title="Checkbox"></img>
                      <p className="text-desc">
                        {" "}
                        Flexible in dealing with change with ability to manage
                        multiple priorities and projects, and meet deadlines in
                        a fast paced environment
                      </p>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* responsibilities-and-experience end */}
        {/* =========================== */}
        {/* Benefits start */}
        <div id="benefits" className="mobile-spacing tablet-spacing">
          <div className="container-fluid p-xs-0 padding-md-0">
            <h2 className="main-head">Benefits</h2>
            <p className="text-desc">
              In our company, education and development is necessary and shows
              in our commitment to your success through our competitive
              compensation and benefits package. We value time and effort and
              want to work to preserve the best possible environment for our
              employees. We work to provide a collaborative, creative
              environment where each person feels encouraged to contribute to
              our processes, decisions, planning and culture.
            </p>
          </div>
          {/* Benefits end */}
        </div>
        <div id="cta" className="bgimg mobile-spacing tablet-spacing">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-8 p-xs-0">
                <h2 className="main-head">How to Apply</h2>
                <p className="text-desc">
                  We’d love to hear from you. Please send your application to{" "}
                  <a href="mailto:info@chawlacpa.com">info@chawlacpa.com</a>,
                  and make sure to include the position title in the subject
                  line so we can review it quickly and connect you with the
                  right person.
                </p>
              </div>
              <div className="col-md-4 btns p-xs-0">
                <a>
                  <button
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#myModal"
                    className="bg-remove-btn-svg"
                  >
                    Apply Now
                    <span>
                      <MdArrowOutward />
                    </span>
                  </button>
                </a>
                {/* Modal */}
                <div className="modal fade" id="myModal">
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-body">
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                        ></button>
                        <div className="modal-body-content">
                          <h2 className="main-head"> We're Hiring </h2>
                          <form ref={form}>
                            <input
                              type="text"
                              name="first_name"
                              placeholder="Enter Name"
                              required
                            />
                            <input
                              type="email"
                              name="email_address"
                              placeholder="Enter Email"
                              required
                            />
                            <input
                              type="tel"
                              name="phone_number"
                              placeholder="Enter Phone No."
                              required
                            />
                            <select name="position_name" id="position" required>
                              {jobListings.map((job, idx) => (
                                <option key={idx} value={job.title}>
                                  {job.title}
                                </option>
                              ))}
                            </select>
                            <input
                              type="file"
                              name="file_name"
                              accept="image/*,application/pdf"
                            />

                            <a
                              href="#"
                              className="common-btn"
                              onClick={sendApplyEmail}
                              style={{
                                pointerEvents: isSending ? "none" : "auto",
                              }}
                            >
                              Submit
                            </a>

                            {statusMessage && (
                              <p
                                className={
                                  statusMessage.includes("successfully")
                                    ? "status-success"
                                    : "status-error"
                                }
                              >
                                {statusMessage}
                              </p>
                            )}
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SeniorTaxAccountant;
